const BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Request failed');
  return data.data ?? data;
}

// Draft
export const getDraft = () => request('/profile-config/draft');

// Section updates
export const updateClientProfile = (fields) =>
  request('/profile-config/draft/client-profile', { method: 'PUT', body: JSON.stringify({ fields }) });

export const updateRiskProfile = (questions, scoreRanges) =>
  request('/profile-config/draft/risk-profile', { method: 'PUT', body: JSON.stringify({ questions, scoreRanges }) });

export const updateGoalProfile = (goalTemplates) =>
  request('/profile-config/draft/goal-profile', { method: 'PUT', body: JSON.stringify({ goalTemplates }) });

export const updateAssetProfile = (assetCategories) =>
  request('/profile-config/draft/asset-profile', { method: 'PUT', body: JSON.stringify({ assetCategories }) });

export const updateLiabilityProfile = (liabilityCategories) =>
  request('/profile-config/draft/liability-profile', { method: 'PUT', body: JSON.stringify({ liabilityCategories }) });

export const updatePreferences = (preferenceTemplates) =>
  request('/profile-config/draft/preferences', { method: 'PUT', body: JSON.stringify({ preferenceTemplates }) });

// Versions
export const publishDraft = (body) =>
  request('/profile-config/publish', { method: 'POST', body: JSON.stringify(body) });

export const getVersions = () => request('/profile-config/versions');
export const getVersion = (id) => request(`/profile-config/versions/${id}`);
export const activateVersion = (id) =>
  request(`/profile-config/versions/${id}/activate`, { method: 'POST' });
export const getActiveVersion = () => request('/profile-config/active');
